module.exports = {"522723001":"金南街道","522723002":"宝山街道","522723102":"新巴镇","522723108":"德新镇","522723109":"盘江镇","522723110":"沿山镇","522723111":"昌明镇","522723112":"云雾镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/522723.json
// module id = 2663
// module chunks = 0